const map = {
	"./best-supplements-for-men-over-50.md": 793,
	"./brain-fog-menopause-andropause.md": 236,
	"./does-hrt-cause-weight-gain.md": 409,
	"./does-hrt-stop-working-over-time.md": 296,
	"./hormone-health-guide-50s.md": 283,
	"./hormone-myths-debunked.md": 445,
	"./hormones-across-life-stages.md": 856,
	"./hormones-in-your-50s-guide.md": 443,
	"./night-sweats-hormonal-changes.md": 174,
	"./night_sweats_hormones_40s_50s.md": 623,
	"./perimenopause-40s-hormonal-changes.md": 698,
	"./supplement-stacks-hormonal-balance-50s.md": 88,
	"./supplements-for-women-50s.md": 952,
	"./why-hot-flushes-worse-at-night-sleep.md": 629,
	"./your-40s-hormone-changes-guide.md": 771
};


function webpackContext(req) {
	const id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 382;